/* ============================================================
   LIEBLICH — Global JavaScript
   ============================================================ */

(function () {
  'use strict';

  // ── HEADER SCROLL ──
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── WISHLIST HELPERS ──
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('lieblich_wishlist') || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem('lieblich_wishlist', JSON.stringify(list));
  }

  // ── DRAWERS ──
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('open');
    document.body.style.overflow = 'hidden';
    el.setAttribute('aria-hidden', 'false');
    if (id === 'cart-drawer') refreshCartDrawer();
    if (id === 'wishlist-drawer') refreshWishlistDrawer();
  }
  function closeDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('open');
    document.body.style.overflow = '';
    el.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer(this.dataset.drawer);
    });
  });
  document.querySelectorAll('[data-close-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(this.dataset.closeDrawer);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ['cart-drawer','wishlist-drawer','search-drawer','mobile-menu'].forEach(closeDrawer);
    }
  });

  // ── CART DRAWER REFRESH ──
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;

        var body = document.getElementById('cart-drawer-body');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<p style="text-align:center;padding:40px;font-family:Poppins,sans-serif;font-size:1.2rem;color:var(--color-primary)">Your cart is empty ♥</p>';
          return;
        }
        var html = cart.items.map(function (item) {
          return '<div class="cart-item" data-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-item-img-wrap"><img src="' + item.image + '" width="80" height="80" loading="lazy" alt="' + item.title + '"></a>' +
            '<div class="cart-item-info">' +
              '<h3 class="cart-item-title">' + item.product_title + '</h3>' +
              (item.variant_title !== 'Default Title' ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '') +
              '<p class="cart-item-price">' + formatMoney(item.final_line_price) + '</p>' +
              '<p class="cart-item-qty-label" style="font-size:0.75rem;color:#6a4050;margin-top:4px;">Qty: ' + item.quantity + '</p>' +
            '</div>' +
            '<button class="cart-remove" data-key="' + item.key + '" aria-label="Remove">×</button>' +
          '</div>';
        }).join('');
        body.innerHTML = html;

        body.querySelectorAll('.cart-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            updateCart(this.dataset.key, 0);
          });
        });
      });
  }

  function formatMoney(cents) {
    return 'PKR ' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { refreshCartDrawer(); })
      .catch(console.error);
  }

  // ── WISHLIST DRAWER REFRESH ──
  function refreshWishlistDrawer() {
    var body = document.getElementById('wishlist-drawer-body');
    if (!body) return;
    var wishlist = getWishlist();
    if (wishlist.length === 0) {
      body.innerHTML = '<p style="text-align:center;padding:40px;font-family:var(--font-hand);font-size:1.2rem;color:var(--color-primary)">Your wishlist is empty ♥</p>';
      return;
    }
    body.innerHTML = '<p style="text-align:center;padding:20px;color:#999;">Loading...</p>';
    fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        var html = '';
        var found = 0;
        wishlist.forEach(function (id) {
          var p = products.find(function (prod) { return String(prod.id) === String(id); });
          if (p) {
            found++;
            var img = p.images && p.images[0] ? p.images[0].src : '';
            var price = p.variants && p.variants[0] ? p.variants[0].price : '0.00';
            html += '<div class="wishlist-item" data-id="' + p.id + '">' +
              '<a href="/products/' + p.handle + '" class="wishlist-item-img-wrap"><img src="' + img + '" width="80" height="80" loading="lazy" alt="' + p.title + '"></a>' +
              '<div class="wishlist-item-info">' +
                '<h3 class="wishlist-item-title">' + p.title + '</h3>' +
                '<p class="wishlist-item-price">PKR ' + parseInt(price).toLocaleString() + '</p>' +
              '</div>' +
              '<button class="wishlist-remove" data-id="' + p.id + '" aria-label="Remove">×</button>' +
            '</div>';
          }
        });
        if (found === 0) {
          body.innerHTML = '<p style="text-align:center;padding:40px;font-family:var(--font-hand);font-size:1.2rem;color:var(--color-primary)">Your wishlist is empty ♥</p>';
          return;
        }
        body.innerHTML = html;
        body.querySelectorAll('.wishlist-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var removeId = this.dataset.id;
            var list = getWishlist();
            var idx = list.indexOf(removeId);
            if (idx !== -1) list.splice(idx, 1);
            saveWishlist(list);
            document.querySelectorAll('.wishlist-btn[data-product-id="' + removeId + '"]').forEach(function (b) { b.classList.remove('active'); });
            refreshWishlistDrawer();
          });
        });
      });
  }

  // ── ADD TO CART ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-atc');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
    var formEl = document.getElementById('productForm');

    if (formEl) {
      // product page — use form data
      var fd = new FormData(formEl);
      var id = fd.get('id');
      var qty = fd.get('quantity') || 1;
      addToCart(id, qty, btn);
    } else if (variantId) {
      addToCart(variantId, 1, btn);
    }
  });

  function addToCart(variantId, qty, btn) {
    var origText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        btn.textContent = '♥ Added!';
        fireEnvelopeAnimation(btn);
        refreshCartDrawer();
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled = false;
          openDrawer('cart-drawer');
        }, 1200);
      })
      .catch(function () {
        btn.textContent = origText;
        btn.disabled = false;
      });
  }

  // ── ATC ENVELOPE ANIMATION ──
  function fireEnvelopeAnimation(sourceEl) {
    var cartIcon = document.querySelector('.cart-icon');
    if (!cartIcon || !sourceEl) return;

    var srcRect = sourceEl.getBoundingClientRect();
    var tgtRect = cartIcon.getBoundingClientRect();

    var env = document.createElement('div');
    env.className = 'atc-envelope';
    env.innerHTML = '<svg viewBox="0 0 36 28" fill="none"><rect x="1" y="5" width="34" height="22" rx="3" fill="#f8d6e1" stroke="#e04375" stroke-width="1.5"/><path d="M1 8 L18 18 L35 8" stroke="#e04375" stroke-width="1.5" fill="none"/></svg>';

    var startX = srcRect.left + srcRect.width / 2 - 18;
    var startY = srcRect.top + window.scrollY;
    env.style.cssText = 'left:' + startX + 'px;top:' + startY + 'px;' +
      '--dx:' + (tgtRect.left - startX) + 'px;' +
      '--dy:' + (tgtRect.top - startY) + 'px;' +
      '--dx-mid:' + ((tgtRect.left - startX) * 0.5) + 'px;' +
      '--dy-mid:' + ((tgtRect.top - startY) * 0.3 - 60) + 'px;';

    document.body.appendChild(env);
    setTimeout(function () { env.remove(); }, 900);
  }

  // ── PRODUCT GALLERY THUMBNAILS ──
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) {
    var galleryReelEmbed = document.getElementById('galleryReelEmbed');
    var igScriptLoading = false;

    function loadInstagramEmbedScript(callback) {
      if (window.instgrm) { callback(); return; }
      if (igScriptLoading) {
        var waitForIt = setInterval(function () {
          if (window.instgrm) {
            clearInterval(waitForIt);
            callback();
          }
        }, 100);
        return;
      }
      igScriptLoading = true;
      var script = document.createElement('script');
      script.async = true;
      script.src = '//www.instagram.com/embed.js';
      script.onload = function () {
        igScriptLoading = false;
        callback();
      };
      document.body.appendChild(script);
    }

    function showReelEmbed(permalink) {
      if (!galleryReelEmbed || !permalink) return;
      var blockquote = galleryReelEmbed.querySelector('.instagram-media');
      if (blockquote && blockquote.getAttribute('data-instgrm-permalink') !== permalink) {
        blockquote.setAttribute('data-instgrm-permalink', permalink);
        // Clear any previously rendered iframe so Instagram re-processes this blockquote
        blockquote.innerHTML = '';
        blockquote.classList.remove('instagram-media-rendered');
      }
      galleryMain.hidden = true;
      galleryReelEmbed.hidden = false;
      loadInstagramEmbedScript(function () {
        if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
      });
    }

    function showMainImage(src) {
      if (galleryReelEmbed) galleryReelEmbed.hidden = true;
      document.querySelectorAll('.gallery-video').forEach(function (v) { v.hidden = true; v.pause && v.pause(); });
      galleryMain.hidden = false;
      if (src) galleryMain.src = src;
    }

    function showVideo(videoId) {
      if (galleryReelEmbed) galleryReelEmbed.hidden = true;
      galleryMain.hidden = true;
      document.querySelectorAll('.gallery-video').forEach(function (v) { v.hidden = true; v.pause && v.pause(); });
      var video = document.getElementById('gallery-video-' + videoId);
      if (video) video.hidden = false;
    }

    var allThumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
    var currentGalleryIndex = 0;

    function activateThumb(index) {
      if (!allThumbs.length) return;
      if (index < 0) index = allThumbs.length - 1;
      if (index >= allThumbs.length) index = 0;
      currentGalleryIndex = index;
      allThumbs[index].click();
    }

    allThumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        currentGalleryIndex = i;
        allThumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');

        if (this.classList.contains('gallery-thumb--reel')) {
          showReelEmbed(this.dataset.reelUrl);
        } else if (this.classList.contains('gallery-thumb--video')) {
          showVideo(this.dataset.videoId);
        } else {
          showMainImage(this.dataset.src);
        }
      });
    });

    // ── DESKTOP PREV/NEXT ARROWS ──
    var prevBtn = document.getElementById('galleryPrev');
    var nextBtn = document.getElementById('galleryNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { activateThumb(currentGalleryIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { activateThumb(currentGalleryIndex + 1); });

    // ── MOBILE SWIPE ──
    var galleryWrap = document.getElementById('galleryMainWrap');
    if (galleryWrap) {
      var swipeStartX = 0, swipeStartY = 0;
      galleryWrap.addEventListener('touchstart', function (e) {
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
      }, { passive: true });
      galleryWrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swipeStartX;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          activateThumb(dx < 0 ? currentGalleryIndex + 1 : currentGalleryIndex - 1);
        }
      }, { passive: true });
    }
  }

  // ── PRODUCT TABS ──
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById('tab-' + tab);
      if (panel) panel.classList.add('active');
    });
  });

  // ── QTY CONTROLS ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var action = btn.dataset.action;
    var input = btn.closest('.qty-control')?.querySelector('.qty-input') ||
                btn.parentElement?.querySelector('.qty-input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    if (action === 'plus') input.value = val + 1;
    if (action === 'minus' && val > 1) input.value = val - 1;

    // cart page update
    var key = btn.dataset.key;
    if (key) updateCart(key, parseInt(input.value));
  });

  // ── VARIANT SELECTION (product page) ──
  var variantInput = document.getElementById('variantId');
  if (variantInput) {
    var productData = window.__productVariants || [];

    // On load: if current variant is unavailable, auto-select first available
    if (productData.length) {
      var currentId = parseInt(variantInput.value);
      var currentVariant = productData.find(function(v) { return v.id === currentId; });
      if (currentVariant && !currentVariant.available) {
        var firstAvail = productData.find(function(v) { return v.available; });
        if (firstAvail) {
          variantInput.value = firstAvail.id;
          var sizeGroup = document.querySelector('.size-buttons');
          if (sizeGroup) {
            sizeGroup.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
            var targetBtn = sizeGroup.querySelector('[data-value="' + firstAvail.options[0] + '"]');
            if (targetBtn) targetBtn.classList.add('active');
          }
        }
      }
    }

    document.querySelectorAll('.size-btn, .color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = this.closest('[data-option-position]');
        group.querySelectorAll('.size-btn, .color-swatch').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        updateVariant();
      });
    });

    // Sync button state on page load
    updateVariant();

    function updateVariant() {
      // Collect selected options
      var opts = [];
      document.querySelectorAll('[data-option-position]').forEach(function (group) {
        var active = group.querySelector('.size-btn.active, .color-swatch.active, select');
        if (active) opts.push(active.dataset?.value || active.value);
      });
      // Try to match variant (exact match first, then partial for hidden single-value options)
      var match = productData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match && opts.length < productData[0].options.length) {
        match = productData.find(function (v) {
          return opts.every(function (o, i) { return v.options[i] === o; });
        });
      }
      if (match) {
        variantInput.value = match.id;
        var priceEl = document.getElementById('productPrice');
        if (priceEl) {
          var priceHtml = '<span class="price-sale">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price > match.price) {
            priceHtml += '<span class="price-compare">' + formatMoney(match.compare_at_price) + '</span>';
            if (priceEl.getAttribute('data-intro') === 'true') {
              priceHtml += '<span class="price-intro-label">halloween</span>';
            }
          }
          priceEl.innerHTML = priceHtml;
        }
        var atcBtn = document.getElementById('atcBtn');
        var preorderNote = document.querySelector('.preorder-note');
        var notifyRestock = document.getElementById('notifyRestock');
        var buyNowBtn = document.getElementById('buyNowBtn');
        if (atcBtn) {
          var isPreorder = match.available && match.inventory_quantity <= 0 && match.inventory_policy === 'continue';
          if (match.available && !isPreorder) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
            atcBtn.classList.remove('btn-sold-out', 'btn-preorder');
            if (preorderNote) preorderNote.style.display = 'none';
            if (notifyRestock) notifyRestock.style.display = 'none';
            if (buyNowBtn) buyNowBtn.style.display = '';
          } else if (isPreorder) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Pre-order Now';
            atcBtn.classList.remove('btn-sold-out');
            atcBtn.classList.add('btn-preorder');
            if (preorderNote) preorderNote.style.display = '';
            if (notifyRestock) notifyRestock.style.display = 'none';
            if (buyNowBtn) buyNowBtn.style.display = 'none';
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Sold Out';
            atcBtn.classList.add('btn-sold-out');
            atcBtn.classList.remove('btn-preorder');
            if (preorderNote) preorderNote.style.display = 'none';
            if (notifyRestock) notifyRestock.style.display = '';
            if (buyNowBtn) buyNowBtn.style.display = 'none';
          }
          atcBtn.dataset.variantId = match.id;
        }
      }
    }
  }

  // ── SCROLL REVEAL (IntersectionObserver) ──
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // fallback
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  // ── NOTIFY ME (RESTOCK) ──
  var notifyBtn = document.getElementById('notifyBtn');
  if (notifyBtn) {
    notifyBtn.addEventListener('click', function () {
      var emailInput = document.getElementById('notifyEmail');
      var email = emailInput.value.trim();
      if (!email || !email.includes('@')) {
        emailInput.style.borderColor = '#e04375';
        return;
      }
      var productTitle = document.querySelector('.product-title')?.textContent || '';
      var variant = document.getElementById('variantId')?.value || '';
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&contact[email]=' + encodeURIComponent(email) +
              '&contact[body]=' + encodeURIComponent('Notify restock: ' + productTitle + ' (variant: ' + variant + ')') +
              '&contact[tags]=restock-notify'
      }).then(function () {
        document.getElementById('notifyForm').style.display = 'none';
        document.getElementById('notifySuccess').style.display = 'block';
      });
    });
  }

  // ── CARD NOTIFY (collection/grid) ──
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.card-notify-toggle');
    if (toggle) {
      var wrap = toggle.closest('.card-notify');
      toggle.style.display = 'none';
      wrap.querySelector('.card-notify-form').style.display = '';
      return;
    }
    var submitBtn = e.target.closest('.card-notify-btn');
    if (submitBtn) {
      var wrap = submitBtn.closest('.card-notify');
      var emailInput = wrap.querySelector('.card-notify-email');
      var email = emailInput.value.trim();
      if (!email || !email.includes('@')) {
        emailInput.style.borderColor = '#e04375';
        return;
      }
      var productTitle = wrap.dataset.productTitle || '';
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&contact[email]=' + encodeURIComponent(email) +
              '&contact[body]=' + encodeURIComponent('Notify restock: ' + productTitle) +
              '&contact[tags]=restock-notify'
      }).then(function () {
        wrap.innerHTML = '<p class="card-notify-success">We\'ll let you know! ♥</p>';
      });
    }
  });

  // ── FILTER GROUP TOGGLES ──
  document.querySelectorAll('.filter-group-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var opts = this.nextElementSibling;
      var expanded = this.getAttribute('aria-expanded') !== 'false';
      this.setAttribute('aria-expanded', !expanded);
      opts.style.display = expanded ? 'none' : '';
    });
  });

  // ── WISHLIST BUTTONS ──
  function initWishlistButtons() {
    var wishlist = getWishlist();
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id) return;
      if (wishlist.indexOf(id) !== -1) btn.classList.add('active');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var currentList = getWishlist();
        var idx = currentList.indexOf(id);
        if (idx === -1) {
          currentList.push(id);
          this.classList.add('active');
        } else {
          currentList.splice(idx, 1);
          this.classList.remove('active');
        }
        saveWishlist(currentList);
      });
    });
  }
  initWishlistButtons();

})();
